import { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Form/OwnerNCR/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_ships,
} from '../../../actions/v2/projectAndVessel';

import Swal from 'sweetalert2';
import { v2_yards } from '../../../actions/v2/masterData';
import { v2_user_by_roles } from '../../../actions/v2/user';
import { v3_fetchNewBuildingotentialVariationOrderFormFields, v3_fetchNewBuildingSiteQueryFields, v3_submitNewBuildinOwnerNCRForm, v3_submitNewBuildinPotentialVariationOrderForm, v3_submitNewBuildinSiteQuery } from '../../../actions/v3/siteManagement';

const NewBuildingBlockInspectionStatus = (props) => {
    const location = useLocation();
    const { data } = location.state || {};

    const [state, setState] = useState({
        comment: { name: 'comment', value: '', error: '', isRequired: true },
        description: { name: 'description', value: '', error: '', isRequired: true },
        builder_reply: { name: 'builder_reply', value: '', error: '', isRequired: false },
        photos: [],
        photoPreview: []

    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        const newPreviews = files.map((file) => URL.createObjectURL(file));

        setState((prev) => ({
            ...prev,
            photos: [...prev.photos, ...files],           // actual files
            photoPreview: [...prev.photoPreview, ...newPreviews] // preview urls
        }));
    };



    // ✅ Common details (only 5 fields)
    const [commonDetails, setCommonDetails] = useState({
        ship: { value: '', options: [], error: '' },
        date: { value: '', error: '' },
        ocr_number: { value: '', error: '' },
        location: { value: '', error: '' },
        deadline: { value: '', error: '' },
        finalSubmit: { value: false },
    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        // v2_user_by_roles().then((res) => {
        //     if (res.status) {
        //         setCommonDetails((prev) => ({
        //             ...prev,
        //             originatedBy: { ...prev.originatedBy, options: res.result },
        //         }));
        //     }
        // });

    }, []);

    // Load ships when project changes
    useEffect(() => {
        v2_ships(null, null, null).then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    ship: { ...prev.ship, options: res.result },
                }));
            }
        });

    }, []);

    // useEffect(() => {
    //     const params = data ? JSON.parse(atob(data)) : null;

    //     if (params) {
    //         setShowLoader(true);

    //         v3_fetchNewBuildingotentialVariationOrderFormFields(params.FORM_ID)
    //             .then((res) => {
    //                 if (res.status) {
    //                     const { records } = res.result;

    //                     // Set common details
    //                     if (params.FORM_ID) {
    //                         setCommonDetails((prev) => ({
    //                             ...prev,
    //                             yard: { ...prev.yard, value: res.result.commonDetails?.YARD_ID || '' },
    //                             ship: { ...prev.ship, value: res.result.commonDetails?.SHIP_ID || '' },
    //                             date: { ...prev.date, value: res.result.commonDetails?.SUBMISSION_DATE || '' },
    //                             finalSubmit: { ...prev.finalSubmit, value: Boolean(res.result.commonDetails?.FINAL_SUBMITTED) },
    //                             originatedBy: { ...prev.originatedBy, value: res.result.commonDetails?.ORIGINATED_BY || '' },
    //                             yardReference: { ...prev.yardReference, value: res.result.commonDetails?.YARD_REFERENCE || '' },
    //                             sq_reference_number: { ...prev.sq_reference_number, value: res.result.commonDetails?.REFERENCE_NUMBER || '' },
    //                             subject: { ...prev.subject, value: res.result.commonDetails?.SUBJECT || '' },
    //                         }));

    //                         // Set state fields

    //                         setState((prev) => ({
    //                             ...prev,
    //                             contract_clause: { ...prev.contract_clause, value: records?.CONTRACT_CLAUSE || '' },

    //                             specification_reference: { ...prev.specification_reference, value: records?.SPECIFICATION_REFERENCE || '' },
    //                             drawing_number: { ...prev.drawing_number, value: records?.DRAWING_NUMBER || '' },
    //                             standard_reference: { ...prev.standard_reference, value: records?.STANDARDS_REFERENCE || '' },
    //                             other: { ...prev.other, value: records?.OTHER || '' },
    //                             estimated_cost_impact: { ...prev.estimated_cost_impact, value: records?.ESTIMATED_COST_IMPACT || '' },
    //                             estimated_time_impact: {
    //                                 ...prev.estimated_time_impact,
    //                                 value: records?.ESTIMATED_TIME_IMPACT || ''
    //                             },

    //                             other_possible_consequenses: {
    //                                 ...prev.other_possible_consequenses,
    //                                 value: records?.OTHER_POSSIBLE_CONSEQUESNSES || ''
    //                             },

    //                             description: {
    //                                 ...prev.description,
    //                                 value: records?.DESCRIPTION || ''
    //                             },
    //                         }));

    //                     }

    //                 } else {
    //                     toast.error(res.error || 'Error fetching NCR form data');
    //                 }
    //             })
    //             .catch(() => {
    //                 toast.error('Something went wrong while fetching.');
    //             })
    //             .finally(() => {
    //                 setShowLoader(false);
    //             });
    //     }
    // }, []);


    const onSubmit = async () => {
        const errors = [];
        debugger
        if (!commonDetails.ship.value) errors.push('Select a ship.');
        if (!commonDetails.ocr_number.value) errors.push('Enter OCR number.');
        if (!commonDetails.date.value) errors.push('Select a date.');
        if (!commonDetails.location.value) errors.push('Enter location.');
        if (!commonDetails.deadline.value) errors.push('Enter deadline.');

        if (commonDetails.finalSubmit.value) {
            Object.entries(state).forEach(([key, field]) => {
                if (!Array.isArray(field)) {
                    if (field.isRequired && !field.value) {
                        errors.push(`${key.replace(/_/g, ' ')} is required.`);
                    }
                }
            });
        }

        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }

        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });
            if (!confirmResult.isConfirmed) return;
        }

        // ✅ Prepare FormData
        const formData = new FormData();

        // --- Append commonDetails ---
        formData.append("ship", commonDetails.ship.value);
        formData.append("date", commonDetails.date.value);
        formData.append("ocr_number", commonDetails.ocr_number.value);
        formData.append("location", commonDetails.location.value);
        formData.append("deadline", commonDetails.deadline.value);
        formData.append("finalSubmit", commonDetails.finalSubmit.value ? 1 : 0);

        // --- Append checklistItems (with files) ---
        Object.keys(state).forEach((key) => {
            const value = state[key];

            if (Array.isArray(value)) {
                // Multiple files or values
                value.forEach((v) => {
                    formData.append(`${key}[]`, v);
                });
            } else if (value instanceof File || value instanceof Blob) {
                formData.append(key, value);
            } else if (value && typeof value === "object" && "value" in value) {
                formData.append(key, value.value);
            } else {
                formData.append(key, value);
            }
        });

        setShowLoader(true);
        v3_submitNewBuildinOwnerNCRForm(formData)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(
                        constant.Authedcomponent.submittedDrawingList.url
                    );
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };



    return (
        <Layout title="Drawing List Form">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>OWNER NON CONFORMITY REPORT
                                            </h4>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    {/* Top Common Form (Ship, Date, OCR, Location, Deadline) */}
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 pl10"><p>Ship</p></td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            disabled={!!data}
                                                            value={commonDetails.ship.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    ship: { ...prev.ship, value: e.target.value },
                                                                }))
                                                            }
                                                        >
                                                            <option value={''}>Select Ship</option>
                                                            {commonDetails.ship.options.map((item) => (
                                                                <option key={item.ID} value={item.ID}>
                                                                    {item.HULL_NUMBER} - {item.SHIP_NAME}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>

                                                    <td className="hd-s2"><p>Date</p></td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={commonDetails.date.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    date: { ...prev.date, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>

                                                    <td className="hd-s2 pl10"><p>Deadline</p></td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={commonDetails.deadline.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    deadline: { ...prev.deadline, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="hd-s2 pl10"><p>OCR Number</p></td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={commonDetails.ocr_number.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    ocr_number: { ...prev.ocr_number, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>

                                                    <td className="hd-s2"><p>Location</p></td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={commonDetails.location.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    location: { ...prev.location, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                handleFileChange={handleFileChange}
                                state={state}
                                onSubmit={onSubmit}
                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus